module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_EL-5c35f07aa778880b1b5f11eb82a964fe.svg";